import { IoCloseOutline } from 'react-icons/io5';
import styled, { css, keyframes } from 'styled-components';

import { preventTextSelection } from '../shared.style';

interface DebugProps {
  $debug?: boolean;
}

interface WrapperModalProps extends DebugProps {
  $isVisible: boolean;
  $shouldRender: boolean;
}

interface ContentModalProps extends DebugProps {
  $isVisible: boolean;
  $extendsBottomPadding: boolean | undefined;
  $customSizeModal?: { width: number; height: number } | null;
}

interface ModalBodyProps extends DebugProps {}

export const StyledWrapperModal = styled.section<WrapperModalProps>`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 999999999;
  padding: 0;
  margin: 0;
  overflow: hidden;
  display: ${({ $shouldRender }) => ($shouldRender ? 'flex' : 'none')};
  animation: ${({ $isVisible }) => ($isVisible ? fadeIn : fadeOut)} 0.5s
    ease-in-out;
  animation-fill-mode: forwards;
  align-items: center;
  justify-content: center;
`;

export const StyledContentModal = styled.section<ContentModalProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: white;
  border-radius: 15px;
  padding: 1rem;
  padding-bottom: ${({ $extendsBottomPadding }) =>
    $extendsBottomPadding ? '1.6rem' : '1rem'};
  margin: 1rem;
  width: 100%;
  max-width: ${({ $customSizeModal }) => ($customSizeModal ? `${$customSizeModal.width}%` : '448px')};
  height: ${({ $customSizeModal }) => ($customSizeModal ? `${$customSizeModal.height}%` : 'auto')};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

  animation: ${({ $isVisible }) =>
    $isVisible
      ? css`
          ${slideInFromBottom} 0.5s ease-out, ${fadeIn} 0.5s ease-out
        `
      : css`
          ${slideOutToBottom} 0.5s ease-in, ${fadeOut} 0.5s ease-in
        `};

  @media (max-width: 1200px) {
    width: 92%;
  }
`;

export const StyledHeaderModal = styled.header`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 0 0.8rem 0.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const StyledCloseModal = styled(IoCloseOutline)`
  font-size: 1.5rem;
  margin-right: 0.7rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.accent.primary};
`;

export const StyledModalBody = styled.section<ModalBodyProps>`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 1rem;
  max-height: 600px;
  overflow-y: auto;
`;

export const StyledTitleModal = styled.h2`
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24.2px;
  text-align: left;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  padding: 0;
  text-align: left;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
  ${preventTextSelection()}
`;
export const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

export const fadeOut = keyframes`
  from { opacity: 1 }
  to { opacity: 0 }
`;

export const slideInFromBottom = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const slideOutToBottom = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;
